import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  value: null
}
const _hoisted_3 = ["value", "selected"]

import { SelectOptionType } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormControlSelect',
  props: {
    placeholder: null,
    choices: null,
    modelValue: null,
    error: null
  },
  emits: ["update:model-value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:model-value', v: string | number | null): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  placeholder?: string;
  choices: SelectOptionType[];
  modelValue?: string | number | null;
  error?: string;
};





const doEmit = (e: Event | InputEvent) => {
  const selectedIndex = (e.target as HTMLSelectElement).selectedIndex;
  let selectedValue = null

  if (props.choices) {
    if (!props.placeholder) {
      selectedValue = props.choices[selectedIndex].value;
    } else {
      if (selectedIndex > 0) {
        selectedValue = props.choices[selectedIndex - 1].value;
      }
    }
  }
  
  emit("update:model-value", selectedValue);
}

return (_ctx: any,_cache: any) => {
  const _component_Error = _resolveComponent("Error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      class: _normalizeClass(["form-control", { error: __props.error }]),
      onChange: doEmit
    }, [
      (__props.placeholder)
        ? (_openBlock(), _createElementBlock("option", _hoisted_2, _toDisplayString(__props.placeholder), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.choices, (v, k) => {
        return (_openBlock(), _createElementBlock("option", {
          key: k,
          value: v.value,
          selected: v.value == __props.modelValue
        }, _toDisplayString(v.label), 9, _hoisted_3))
      }), 128))
    ], 34),
    _createVNode(_component_Error, { error: __props.error }, null, 8, ["error"])
  ]))
}
}

})